import { render, staticRenderFns } from "./Phylum.vue?vue&type=template&id=33645f29&"
import script from "./Phylum.vue?vue&type=script&lang=js&"
export * from "./Phylum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports